import CountryOpening from './CountryOpening'

export default CountryOpening
